// extracted by mini-css-extract-plugin
export default {"rating":"ZA-z","numberOfStars":"_A-z","count":"aB-z","barGraphSpacing":"bB-z","barGraph":"cB-z"};